import * as React from "react";
import PropTypes from "prop-types";

import LoaderWrapper from "../../wrapper/LoaderWrapper";
import { StyledTableCell, StyledTableRow } from "../../base/BaseTable/BaseTable";

function areRowDataPropsEqual(oldProps, newProps) {
  return (
    oldProps.isLoading === newProps.isLoading
  );
}

const FilterTableLoadingRow = React.memo((props) => {


  return (
    <>
    {props.isLoading &&
    <StyledTableRow>
      <StyledTableCell
        colSpan={props.colSpan}
      >
        <LoaderWrapper showLoader={props.isLoading} />
      </StyledTableCell>
    </StyledTableRow>
    }
    </>
  );
}, areRowDataPropsEqual);

export default FilterTableLoadingRow;

FilterTableLoadingRow.propTypes = {
  isLoading: PropTypes.bool,
  colSpan: PropTypes.number
};

FilterTableLoadingRow.defaultProps = {
  isLoading: false,
  colSpan: 1
};
